<!--
  功能：自选股策略详情页(自选股)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2025-07-11 11:02:52
  版本：v2.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div :class="$route.query.themeStyleVs == '2' ? 'black_theme hot_page' : 'themeWhite hot_page'">

    <!-- 详情 -->
    <div class="main contant_main"  >


         <!-- 标题,描述 -->
        <div class="head">
          <div class="title">{{ titleText }}</div>
          <div class="desc">{{ descText }} <span class="head-desc-but" @click="gotoDescUrl()" > 查看详情 >> </span> </div>
        </div>




      <!-- 当前信号池 -->
      <div class="mod">
        <div class="mod-hd">
          <span>当前信号池</span>
          <em>({{ zxgStocks.length }})</em>
        </div>
        <div class="mod-bd stockList " v-show="!stockLoading"  >
          <div class="table dqxhc">
            <div class="thead flex">
              <div class="th">名称/代码</div>
              <div class="th">最新</div>
              <div class="th">涨跌幅</div>
            </div>
            <div class="tbody">
              <div
                class="tr flex"
                v-for="(itemZxg, indexZxg) in zxgStocks"
                :key="indexZxg"
                @click="gotoStock(itemZxg.Obj)"
              >
                <div class="td">
                  <span>{{ itemZxg.ZhongWenJianCheng }}</span>
                  <em>{{ cleanStockCode(itemZxg.Obj) }}</em>
                </div>
                <div class="td">
                  <span>{{ toFixedNum(itemZxg.ZuiXinJia, 2, '') }}</span>
                </div>
                <div class="td">
                  <b :class="[judgeColor(itemZxg.ZhangFu)]">{{
                    toFixedNum(itemZxg.ZhangFu, 2, '%')
                  }}</b>
                </div>

                <!-- 加锁 -->
                <!-- <div class="lock" v-show="itemZxg.hidden == 1" @click.stop="gotoShopUrl()">
                  <i class="icon-lock"></i>
                  <span>解锁重要信号</span>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <van-loading size="24px" v-show="stockLoading" vertical style="height: 100vh;" >加载中...</van-loading>
      </div>
      <!-- 调入/出记录 -->
      <div class="mod">
        <div class="mod-hd">
          <span>信号发出记录</span>
        </div>
        <div class="mod-bd" v-if="inOutList.length > 0">
          <div class="xhfcjl">
            <div class="table-title">
              <van-row gutter="10">
                <van-col span="8">调整时间</van-col>
                <van-col span="5">调整股票</van-col>
                <van-col span="6" class="table-title-mid">信号</van-col>
                <van-col span="5" class="table-title-rigth">调整价</van-col>
              </van-row>
            </div>

            <div>
              <div v-for="(itemInto, indexInto) in inOutList" :key="indexInto">
                <!-- 分割线 -->
                <van-divider class="division_info" v-show="indexInto !== 0"> </van-divider>

                <div class="table-content">
                  <van-row gutter="10" type="flex">
                    <van-col span="8">
                      <div class="date">
                        <span>{{ formatDateToStr(itemInto.date) }}</span>
                        <span>{{ formatTimeToStr(itemInto.time) }}</span>
                      </div>
                    </van-col>
                    <van-col span="5">
                      <div class="stock-info" @click.stop="gotoStock(itemInto.stockCode)">
                        <span class="stock-info-title">{{ itemInto.stockName }}</span>
                        <em>{{ cleanStockCode(itemInto.stockCode) }}</em>
                      </div>
                    </van-col>
                    <van-col span="6" class="table-content-mid">
                      <b
                        class="table-tag"
                        :class="itemInto.type == 1 ? 'green-background' : 'red-background'"
                        >{{ itemInto.type == 1 ? '预警' : '信号增强' }}</b
                      >
                    </van-col>
                    <van-col span="5">
                      <span class="table-price">{{ itemInto.price }}</span>
                    </van-col>
                  </van-row>
                </div>

                <!-- 发出理由 -->
                <div class="table-reason">
                  <img class="reason-img" src="@/assets/image/hedging/fcly.png" alt="" srcset="" />
                  <div class="reason-desc lock-info" v-if="itemInto.hidden == 1"  @click="gotoShopUrl()"   >
                    <span>{{ itemInto.reason }}</span>

                  </div>
                  <div v-else class="reason-desc" >
                    <span>{{ itemInto.reason }}</span>
                    <div
                      class="link-button"
                      v-show="itemInto.link"
                      @click.stop="gotoLink(itemInto)"
                    >
                      查看 <van-icon name="arrow" />
                    </div>
                  </div>
                  <!-- 加锁 -->
                  <div class="lock" v-show="itemInto.hidden == 1" @click="gotoShopUrl()"  >
                    <i class="icon-lock"></i>
                    <span>解锁重要信号</span>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- 展开收起 -->
          <div class="expand" v-show="showExpand" @click="unfoldPagesFunc()">
            <!-- {{ isExpanded ? '收起' : '展开' }} -->
            展开
            <!-- <van-icon :name="'arrow-' + (isExpanded ? 'up' : 'down')" color="#6b7687"></van-icon> -->
            <van-icon name="arrow-down" color="#6b7687"></van-icon>
          </div>
        </div>
        <div v-else class="empty-info">
          <!-- 空数据 -->
          <img src="@/assets/image/hedging/emptyData.png" alt="" class="empty-png" />
          <p class="empty-text">暂无信号发出记录</p>
        </div>
      </div>
      <div class="mod">
        <div class="mod-hd">
          <span>策略分析</span>
        </div>
        <div class="mod-bd clfx">
          <div class="info">
            本策略自运行以来，为您排除了<em class="green">{{ HedgeCount }}</em
            >次重大风险
            <span v-show="AlphaCount > 0">
              ，捕捉了<em class="red">{{ AlphaCount }}</em
              >次机会
            </span>
            <span v-show="cumulative > 0">
              ，近一周累计为您创造了<em class="red">{{ cumulative }}%</em>的超额收益</span
            >。
          </div>
          <div class="card flex">
            <div class="item" v-if="HedgeCount > 0">
              <div>
                <b class="font-green">{{ HedgeCount }}</b>
                <em class="font-green">次</em>
                <sup class="green">预警</sup>
              </div>
              <div v-if="HedgeCount > 0" :class="AlphaCount > 0 ? '' : 'item-list'">
                <p v-for="(itemHed, indexHed) in HedgeStats" :key="indexHed" :class="HedgeStats.length > 1? 'flex-w50':'flex-w100' "  >
                  <span v-for="(itemI, indexI) in itemHed" :key="indexI">
                    ⚠️ {{ indexI }}: {{ itemI }}次
                  </span>
                </p>
              </div>
            </div>
            <div class="item" v-if="AlphaCount > 0">
              <div>
                <b class="font-red">{{ AlphaCount }}</b>
                <em class="font-red">次</em>
                <sup class="red">增强</sup>
              </div>
              <div v-if="AlphaCount > 0" :class="HedgeCount > 0 ? '' : 'item-list'">
                <p v-for="(itemAlp, indexAlp) in AlphaStats" :key="indexAlp">
                  <span v-for="(itemA, indexA) in itemAlp" :key="indexA">
                    👍 {{ indexA }}: {{ itemA }}次
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="info">近一周回测分析如下：</div>
          <div class="hcfx flex">
            <div class="item">
              <div class="label">调优后收益</div>
              <div class="value" :class="[judgeColor(optInterest)]">
                {{ toFixedNum(optInterest, 2, '%') }}
              </div>
            </div>
            <div class="item">
              <div class="label">未调优收益</div>
              <div class="value" :class="[judgeColor(zxgInterest)]">
                {{ toFixedNum(zxgInterest, 2, '%') }}
              </div>
            </div>
          </div>
          <div class="chart" ref="chart" v-show="showCanvas"></div>
          <div class="tips">
            风险提示：服务存在策略失效风险及市场波动风险。策略模型可能因数据偏差、参数失效、市场环境变化等因素导致不及预期。本服务不涉及投资咨询服务，所示信息仅供参考，不构成投资建议，您需独立判断，谨慎决策，并自行承担投资风险。
          </div>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="fixed-button">
      <!-- <span @click="gotoMnUrl()">创建模拟交易</span> -->
      <span style="color: #fff !important" @click="gotoSpUrl()">实盘交易</span>
    </div>
  </div>
</template>

<script>
import {
  getFactorDetail,
  getYunToken,
  getProfitStrategy,
  getHedgingBackTest,
  getHistoryPages,
  getHedgindSim
} from '@/api/hedging.js';
// 在组件中
import Dzhyun from '@/utils/dzhyun.min.js';
import {
  judgeColor,
  toFixedNum,
  dateFormat,
  formatDateToStr,
  formatTimeToStr,
  cleanStockCode
} from '@/utils/format';

export default {
  name: '',
  data() {
    return {

      // 标题与描述
      titleText: window.hedging_title,
      descText: window.hedging_desc,

      active:1,

      //   详情内容
      isExpanded: false,
      zxgList: [], // 自选股列表
      inOutList: [], // 调入调出记录
      lastout: '',
      zxgStocks: [],
      page: 0,
      count: 3,
      lastId: '',
      showExpand: true,
      // 股票信息
      socket: null,
      // 云Token
      yunToken: '',
      dzhyunObj: null,
      // 避险统计数据
      HedgeStats: [],
      HedgeCount: 0,
      // 增强统计数据
      AlphaStats: [],
      AlphaCount: 0,
      // 因子数据
      factorList: [],
      // 自选股分组id
      groupid: '',

      // 图表数据
      zxgYShaft: [], // Y轴数据
      optimizerYShaft: [], //Y轴数据
      linXShaft: [], // X轴数据
      cumulative: 0, // 累计收益(调优后-调优前)
      zxgInterest: 0,
      optInterest: 0,
      // 画布
      showCanvas: true,
      // loading 加载
      stockLoading:true,
    };
  },
  filters: {},
  // 侦听器
  watch: {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    // console.log('$route.query.themeStyleVs', this.$route.query.themeStyleVs);

    this.groupid = this.$route.query.groupid;
    window.addEventListener('scroll', this.allPageScroll, true);
    // 获取数据
    this.getFactorDetailFunc();
    // 获取统计数据
    this.getHedgingCountFunc();
  },
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted: function () {},
  destroyed() {},
  beforeDestroy() {
    window.removeEventListener('scroll', this.allPageScroll, true);
    this.closeWebSocket();
  },
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    dateFormat,
    formatDateToStr,
    formatTimeToStr,
    cleanStockCode,

    // 获取自选股/历史信号
    getFactorDetailFunc: function () {
      var _this = this;
      getFactorDetail({})
        .then((result) => {
          // console.log('result', result);
          if (result.err == 200) {
            // 获取成功
            _this.zxgList = result.data.list;
            _this.inOutList = result.data.history.list;
            // 记录最后一个
            _this.lastout = result.data.history.list[result.data.history.list.length - 1]?.lastId;

            // 判断
            if (_this.count >= result.data.history.total) {
              _this.showExpand = false;
            }

            // _this.stockLoading = false;
            setTimeout(()=>{
              _this.stockLoading = false;
            },500)


            // 获取云token
            _this.getYunTokenFunc();
            // _this.initWebSocket();
          } else {
            // 获取失败
            _this.zxgList = [];
            _this.inOutList = [];
          }
        })
        .catch((err) => {});
    },
    // 初始化接入websocket
    initWebSocket: function () {
      var _this = this;
      this.dzhyunObj = new Dzhyun({
        address: window.cloud.WSUrl,
        dataType: 'json',
        token: _this.yunToken
      });
      _this.subscribe();
    },
    // 订阅股票信息
    subscribe: function () {
      var _this = this;
      // 获取获取的股票
      var codes = _this.zxgList
        .flat()
        .map((item) => item.code)
        .join(',');
      _this.dzhyunObj.cancel();
      var indexsParams = {
        obj: codes,
        field: 'ZhongWenJianCheng,ZuiXinJia,ZhangFu'
      };
      this.dzhyunObj.subscribe('/quote/stkdata', indexsParams, function (data) {
        if (data.length == _this.zxgList.length) {
          _this.initStocks(data);
        } else {
          _this.updataStocks(data);
        }
      });
    },
    // 初始化股票
    initStocks: function (data) {
      var _this = this;
      const arr1 = _this.zxgList;
      const arr2 = data;

      // 先把 arr1 转成一个以 code 为 key，hidden 为 value 的 Map
      const hiddenMap = {};
      arr1.forEach((item) => {
        hiddenMap[item.code] = item.hidden;
      });

      // 遍历 arr2，根据 Obj 找对应的 hidden 值
      _this.zxgStocks = arr2.map((item) => {
        return {
          ...item,
          hidden: hiddenMap[item.Obj] !== undefined ? hiddenMap[item.Obj] : null
        };
      });
    },
    // 更新股票信息
    updataStocks: function (data) {
      var _this = this;
      data.forEach((updateItem) => {
        const target = _this.zxgStocks.find((item) => item.Obj === updateItem.Obj);
        if (target) {
          target.ZuiXinJia = updateItem.ZuiXinJia;
          target.ZhangFu = updateItem.ZhangFu;
        }
      });
    },
    // 关闭websocket
    closeWebSocket: function () {
      _this.dzhyunObj.cancel();
    },

    // 点击展开获取3条数据
    unfoldPagesFunc: function () {
      var _this = this;

      // _this.showExpand = false;
      var params = {
        lastid: _this.lastout,
        size: _this.count
      };
      getHistoryPages(params)
        .then((result) => {
          if (result.err == 200) {
            // 赋值
            _this.lastout = result.data.list[result.data.list.length - 1]?.lastId;
            _this.inOutList.push(...result.data.list);
            if (result.data.list.length < _this.count) {
              _this.showExpand = false;
            }
          }
        })
        .catch((err) => {});
    },

    // 获取云Token
    getYunTokenFunc: function () {
      var _this = this;
      var params = {
        appid: window.cloud.AppId,
        secret_key: window.cloud.SecretKey
      };
      getYunToken({})
        .then((result) => {
          if (result.err == 200) {
            _this.yunToken = result.data;
            _this.initWebSocket();
          }
        })
        .catch((err) => {});
    },
    // 获取增强必避险统计
    getHedgingCountFunc: function () {
      var _this = this;
      getProfitStrategy({})
        .then((result) => {
          // console.log('result', result);
          if (result.err == 200) {
            // 数据获取成功
            // 避险数据
            _this.HedgeStats = result.data.counts.alarm1 ? result.data.counts.alarm1 : [];
            _this.HedgeCount = result.data.counts.alarm1
              ? result.data.counts.alarm1.reduce((sum, item) => {
                  const value = Object.values(item)[0]; // 每个对象的值
                  return sum + value;
                }, 0)
              : 0;
            // 增强数据
            _this.AlphaStats = result.data.counts.alarm2 ? result.data.counts.alarm2 : [];
            _this.AlphaCount = result.data.counts.alarm2
              ? result.data.counts.alarm2.reduce((sum, item) => {
                  const value = Object.values(item)[0]; // 每个对象的值
                  return sum + value;
                }, 0)
              : 0;
            // 因子数据
            _this.factorList = result.data.factorIds;
            _this.getFactorsGroupLine();
          }
        })
        .catch((err) => {});
    },
    // 获取增强避险的收益(走势)
    getFactorsGroupLine: function () {
      var _this = this;
      Promise.allSettled([this.getHedgingBackTestFunc(), this.getHedgingBackTestFunc2()])
        .then((result) => {
          // console.log('result',result);

          if (result[0].status == 'fulfilled') {
            //未调优的执行成功了;
            _this.zxgYShaft = result[0].value.NetValue.map((item, index) => {
              return (item).toFixed(2);
            }); //最优Y轴
            _this.linXShaft = result[0].value.Tradday.map((item, index) => {
              return _this.dateFormat('YYYY-MM-DD', item);
            }); //时间X轴
            _this.zxgInterest = _this.zxgYShaft.length
              ? _this.zxgYShaft[_this.zxgYShaft.length - 1]
              : 0;
          }

          if (result[1].status == 'fulfilled') {
            // 调优的也执行成功了
            _this.optimizerYShaft = result[1].value.NetValue.map((item, index) => {
              return (item).toFixed(2);
            }); //最优Y轴
            _this.linXShaft = result[1].value.Tradday.map((item, index) => {
              return _this.dateFormat('YYYY-MM-DD', item);
            }); //时间X轴
            _this.optInterest = _this.optimizerYShaft.length
              ? _this.optimizerYShaft[_this.optimizerYShaft.length - 1]
              : 0;
          }

          // 计算收益
          _this.cumulative = (_this.optInterest - _this.zxgInterest).toFixed(2);

          if (result[0].status == 'fulfilled' && result[1].status == 'fulfilled') {
            _this.showCanvas = true;
            _this.$nextTick(function () {
              _this.chartInit();
            });
          } else {
            _this.showCanvas = false;
          }
        })
        .catch((err) => {});
    },

    getHedgingBackTestFunc: function () {
      var _this = this;
      return new Promise((resolve, reject) => {
        let params = {
          type: 1,
          groupid: _this.groupid,
        };
        getHedgindSim(params)
          .then((resDetail) => {
            if (resDetail.err == 200) {
              resolve(resDetail.data);
            } else {
              reject({});
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },
    getHedgingBackTestFunc2: function () {
      var _this = this;
      return new Promise((resolve, reject) => {
        let params = {
          type: 2,
          groupid: _this.groupid,
        };
        getHedgindSim(params)
          .then((resDetail) => {
            // console.log('resDetail', resDetail);
            if (resDetail.err == 200) {
              resolve(resDetail.data);
            } else {
              reject({});
            }
          })
          .catch((err) => {
            reject({});
          });
      });
    },

    // 折线图数据
    chartInit: function () {
      var _self = this;
      var chart = _self.$echarts.init(_self.$refs.chart);
      var option = {
        grid: [
          {
            top: 20,
            bottom: 20,
            left: 40,
            right: 2
          }
        ],
        color: ['#ff9153', '#286df7'],
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            // console.log(params);
            var result = params[0].name + '<br/>';
            params.forEach(function (item) {
              result += item.marker + item.seriesName + '：' + item.value + '%' + '<br>';
            });
            return result;
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLine: {
            lineStyle: {
              color: _self.themeStyleVs == 1 ? '#E8E8E8' : 'rgba(255, 255, 255, 0.1)'
            }
          },
          axisLabel: {
            margin: 6,
            color: '#6b7687',
            showMinLabel: true,
            showMaxLabel: true,
            interval: _self.linXShaft.length - 2,
            formatter: function (value, index) {
              //文本格式化
              if (index === 0) {
                return '{right|' + value + '}';
              } else if (index === _self.linXShaft.length - 1) {
                return '{left|' + value + '}';
              } else {
                return '{left|' + value + '}';
              }
            },
            rich: {
              right: {
                width: 140,
                fontSize: 12,
                align: 'right'
              },
              left: {
                width: 144,
                fontSize: 12,
                align: 'left'
              }
            }
          },
          axisTick: {
            show: false
          },
          data: _self.linXShaft
        },
        yAxis: {
          type: 'value',
          scale: true,
          splitLine: {
            lineStyle: {
              color: _self.themeStyleVs == 1 ? '#E8E8E8' : 'rgba(255, 255, 255, 0.1)'
            }
          },
          axisLabel: {
            color: '#6b7687',
            margin: 2,
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '调优后收益',
            data: _self.optimizerYShaft,
            type: 'line',
            smooth: true,
            itemStyle: {
              opacity: 0
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(255, 136, 9, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 136, 9, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            name: '未调优收益',
            data: _self.zxgYShaft,
            type: 'line',
            smooth: true,
            itemStyle: {
              opacity: 0
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(40, 68, 247, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(40, 68, 247, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      };

      chart.setOption(option);
    },
    // 跳转去购买链接
    gotoShopUrl: function () {
      var _this = this;
      // console.log('_this.getMobileOSType()', _this.getMobileOSType());

      if (_this.getMobileOSType() == 2) {
        window.location.href = window.hedging_shoping_ios;
      } else if (_this.getMobileOSType() == 3) {
        window.location.href = window.hedging_shoping_android;
      } else {
        this.$toast('当前设备不支持购买');
      }
    },
    // 点击跳转到事件
    gotoLink: function (item) {
      // 查询item.link 是否存在B$替换成BI
      if (item.link.includes("B$")) {
        item.link = item.link.replace("B$", "BI");
      }
      window.location.href = item.link;
    },
    // 跳转到股票分时
    gotoStock: function (stockCode) {
      window.location.href = `dzh_browser_url&goto=0&type=2970&code=${stockCode}&kind=1`;
    },
    // 跳转去实盘
    gotoSpUrl: function () {
      window.location.href = window.hedging_shoping_sp;
    },
    // 跳转去模拟交易
    gotoMnUrl: function () {
      // window.location.href = '';
      this.$toast('敬请期待');
    },
    // 点击跳详情
    gotoDescUrl:function(){
      window.location.href = window.hedging_desc_url;
    },
    getMobileOSType: function () {
      const ua = navigator.userAgent || navigator.vendor || window.opera;

      const isIOS = /iPhone|iPad|iPod/i.test(ua);
      const isAndroid = /Android/i.test(ua);
      const isHarmony =
        /dzhhmtablet ohos|ohos|dzhapp ohos|dzhhm2in1 ohos/i.test(ua);

      if (isHarmony) return 4; // 移动鸿蒙终端
      if (isIOS) return 2; // 移动 iOS 终端
      if (isAndroid) return 3; // 移动 Android 终端

      return 1; // pc
    }
  }
};
</script>

<style scoped lang="less">
em {
  font-weight: normal;
  font-style: normal;
}

.flex {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: wrap;
}

.flex-item {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.flex-space-between {
  justify-content: space-between;
}

.flex-wrap {
  flex-wrap: wrap;
}

.navget_main {
  color: #fff;
}

.hot_page {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  .sticky_header {
    .navg_box {
      // background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
      // padding-top: 0;
      background: url('../../assets/image/blockImg/bg.png') no-repeat;
      background-size: 100%;
      .bg_box {
        width: 100%;
        height: 100%;
        padding-top: 44px;
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 170px;
      }
    }
  }
  .navg_box {
    width: 100%;
    padding-top: 0px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    .bg_box {
      padding-top: 44px;
    }
  }
  header {
    width: 100%;
    background: linear-gradient(198.51deg, #4478ff -6.42%, rgba(239, 242, 250, 0.4) 83.87%);
    .header_main {
      padding-top: 88px;
      background: url(../../assets/image/detail_top.png) no-repeat;
      background-size: 56vh;
    }
  }

  //   标题,描述
  .head {
    padding: 0 16px 30px;
    .title {
      color: #e4e9fe;
      font-size: 22px;
      font-weight: 500;
      margin: 10px 0 0 0;
      line-height: 31px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .desc {
      color: #e4e9fe;
      font-size: 13px;
      margin: 6px 0 0 0;
      line-height: 31px;
      text-align: justify;
      line-height: 20px;
      // display: -webkit-box;
      -webkit-box-orient: vertical;
      // -webkit-line-clamp: 3;
      overflow: hidden;
      .head-desc-but {
        // color: #517acd;
        color: #e4e9fe;
        float: right;
      }
    }
  }

  //   内容
  .main {
    border-radius: 20px 20px 0 0;
    background-color: #0c0f13;
    margin-top: -17px;
    padding-bottom: 72px;
    overflow: hidden;

    .mod {
      background-color: #181a23;
      padding: 14px 16px;
      margin-top: 8px;

      &:first-child {
        margin-top: 0;
      }

      .mod-hd {
        &::before {
          content: '';
          display: inline-block;
          vertical-align: middle;
          width: 3px;
          height: 10px;
          background-color: #3b85fe;
          border-radius: 88px;
          margin-right: 4px;
        }

        span {
          vertical-align: middle;
          line-height: 22px;
          color: #e4e9fe;
          font-size: 16px;
          font-weight: 600;
        }

        em {
          vertical-align: middle;
          color: #aab9d1;
          font-size: 12px;
        }
      }

      .stockList {
        min-height: 30px;
      }
    }

    .table {
      margin-top: 12px;

      .thead {
        .th {
          color: #6b7687;
          font-size: 12px;
          text-align: right;
        }
      }

      .tbody {
        .tr {
          position: relative;
          align-items: center;
          height: 53px;

          &.mask {
            .td,
            .fcly {
              filter: blur(6px);
              overflow: initial;
            }
          }

          .lock {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            span {
              display: inline-flex;
              align-items: center;
              justify-content: center;
              padding: 0 14px;
              height: 25px;
              background: #272935;
              border: 1px solid #3b85fe;
              border-radius: 88px;
              color: #3b85fe;
              font-size: 12px;
              white-space: nowrap;
            }
          }

          .td {
            text-align: right;
            overflow: hidden;

            span {
              display: block;
              font-size: 15px;
              color: #e4e9fe;
              font-weight: 500;
              line-height: 21px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            em {
              color: #6b7687;
              font-size: 13px;
              line-height: 18px;
              margin-top: 2px;
            }

            b {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              padding-right: 8px;
              width: 100%;
              height: 23px;
              color: #fff;
              border-radius: 4px;
              background-color: #6b7687;
              font-size: 15px;
              font-weight: 500;

              &.red {
                background-color: #ef3939;
                color: #fff !important;
              }

              &.green {
                background-color: #1eac4e;
                color: #fff !important;
              }
              &.gray {
                background-color: #6b7687;
                color: #fff !important;
              }
            }
          }
        }
      }
    }

    .dqxhc {
      .thead {
        .th {
          &:nth-child(1) {
            flex: 1;
            text-align: left;
          }

          &:nth-child(2) {
            padding-right: 16px;
          }

          &:nth-child(3) {
            flex: 0 0 88px;
          }
        }
      }

      .tbody {
        .tr {
          .td {
            &:nth-child(1) {
              flex: 1;
              text-align: left;
            }

            &:nth-child(2) {
              padding-right: 16px;

              span {
                font-size: 17px;
              }
            }

            &:nth-child(3) {
              flex: 0 0 88px;
            }
          }
        }
      }
    }

    .xhfcjl {
      .table-title {
        color: #aab9d1;
        font-size: 12px;
        margin-top: 12px;
        margin-bottom: 14px;
        .table-title-mid {
          text-align: center;
        }
        .table-title-rigth {
          text-align: right;
        }
      }
      .van-row--flex {
        align-items: center;
      }

      .division_info {
        margin: 14px auto;
      }

      .table-content {
        .date {
          color: #aab9d1;
          span {
            width: 100%;
            display: inline-block;
            font-size: 12px;
          }
        }
        .stock-info {
          color: #aab9d1;
          .stock-info-title {
            font-weight: 500;
            color: #e4e9fe;
            font-size: 15px;
          }
          span {
            width: 100%;
            display: inline-block;
          }
          em {
            color: #6b7687;
            font-size: 12px;
          }
        }

        .table-content-mid {
          text-align: center;
        }

        .table-tag {
          font-size: 13px;
          padding: 2px 8px;
          border-radius: 4px;
        }

        .green-background {
          background: #17341c;
          color: #1eac4e;
        }
        .red-background {
          background: #3b2520;
          color: #ef3939;
        }

        .table-price {
          font-size: 16px;
          text-align: right;
          color: #e4e9fe;
          display: inline-block;
          width: 100%;
        }
      }

      .table-reason {
        line-height: 20px;
        margin-top: 8px;
        position: relative;
        .reason-img {
          width: 56px;
          // height: 20px;
          margin-right: 6px;
          margin-top: 4px;
          float: left;
        }
        .reason-desc {
          color: #e4e9fe;
          font-size: 14px;
        }
        .reason-desc::after {
          content: '';
          display: table;
          clear: both;
        }
        .link-button {
          font-size: 12px;
          color: #517acd;
          float: right;
          // display: inline-block;
          // border: 1px solid red;
        }
      }
      // 锁
      .lock-info {
        filter: blur(6px);
      }
      .lock {
        height: 35px;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-end;
        align-items: center;
        position: absolute;
        top: calc(50% - 15px);
        right: 10px;
        span {
          background: #272935;
          border: 1px solid #3b85fe;
          border-radius: 88px;
          color: #3b85fe;
          font-size: 12px;
          padding: 4px 14px;
        }
      }
    }

    .icon-lock {
      display: inline-block;
      vertical-align: middle;
      width: 48px;
      height: 31px;
      background: url('../../assets/image/hedging/lock.png') no-repeat;
      background-size: 100% auto;
    }

    .expand {
      color: #6b7687;
      text-align: center;
      font-size: 12px;
      padding: 4px 0;
      margin-top: 10px;
    }

    .clfx {
      padding-top: 12px;

      .info {
        font-size: 13px;
        color: #aab9d1;
        em {
          display: inline-block;
          vertical-align: text-bottom;
        }
      }

      .card {
        padding: 12px 0;

        .item {
          position: relative;
          flex: 1;
          background-color: #1d202d;
          color: #aab9d1;
          border-radius: 6px;
          text-align: center;
          padding: 12px 0;

          &:only-child p {
            /* width: 50%; */
            flex: 0 0 50%;
          }
          &:only-child div:nth-child(2) {
            display: flex;
            flex-wrap: wrap;
          }
          &:nth-child(2) {
            margin-left: 8px;
          }

          .item-list {
            display: flex;
            flex-wrap: wrap;
          }

          .item-list p {
            padding: 0 10px;

          }


          // &:first-child {
          //   margin-right: 8px;
          // }

          &::before {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            background-repeat: no-repeat;
            background-size: 100% auto;
          }

          &:nth-child(1)::before {
            width: 48px;
            height: 55px;
            background-image: url('../../assets/image/hedging/bx.png');
          }

          &:nth-child(2)::before {
            width: 52px;
            height: 52px;
            background-image: url('../../assets/image/hedging/zq.png');
          }

          b {
            display: inline-block;
            line-height: 1.4;
            font-weight: 500;
            font-size: 28px;
          }

          em {
            font-weight: 500;
            font-size: 14px;
          }

          sup {
            position: absolute;
            top: 11px;
            left: 50%;
            color: #fff;
            font-size: 8px;
            padding: 1px 2px;
            border-radius: 2px;
            transform: translateX(25px);
            white-space: nowrap;
          }

          // &:nth-child(1) sup {
          //   background-color: #1eac4e;
          //   color: #fff !important;
          // }

          // &:nth-child(2) sup {
          //   background-color: #ef3939;
          //   color: #fff !important;
          // }

          .font-green {
            color: #1eac4e !important;
          }

          sup.green {
            background-color: #1eac4e;
            color: #fff !important;
          }

          .font-red {
            color: #ef3939 !important;
          }

          sup.red {
            background-color: #ef3939;
            color: #fff !important;
          }

          .flex-w50 {
            flex: 0 0 50% !important;
          }
          .flex-w100 {
            flex: 1 !important;
          }
        }
      }

      .hcfx {
        padding: 12px 0;

        .item {
          position: relative;
          flex: 1;
          background-color: #1d202d;
          color: #aab9d1;
          border-radius: 6px;
          text-align: center;
          padding: 12px 0;

          &:first-child {
            margin-right: 8px;
          }

          .label {
            font-size: 12px;
          }

          .value {
            font-size: 22px;
            line-height: 31px;
            margin-top: 2px;
            font-weight: 500;
          }
        }
      }

      .chart {
        height: 200px;
      }

      .tips {
        font-size: 11px;
        color: #6b7687;
        line-height: 1.6;
        text-align: justify;
        margin-top: 14px;
      }
    }
  }
  .fixed-button {
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    height: 62px;
    max-width: 750px;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    padding: 0 16px;
    background-color: #1d202d;

    span {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      border: 1px solid #3b85fe;
      color: #3b85fe;
      font-size: 16px;
      height: 38px;
      border-radius: 6px;

      &:nth-child(1) {
        background-color: #3b85fe;
        color: #fff;
        margin-left: 8px;
      }
    }
  }

  // 空数据
  .empty-info {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    align-items: center;
    .empty-png {
      width: 72px;
      height: 61px;
      margin: 5px auto;
    }
    .empty-text {
      color: #aab9d1;
    }
  }
}
.themeWhite {
  .head {
    .title {
      color: #1d2129 !important;
    }
    .desc {
      color: #373a4d !important;
      .head-desc-but {
        color: #286df7 !important;
      }
    }
  }

  .navget_main {
    color: #1d2129;
  }

  .sticky_header {
    .navg_box {
      background: linear-gradient(198.51deg, #4478ff -5%, rgba(239, 242, 250, 1) 95%);
      padding-top: 0;

      .bg_box {
        width: 100%;
        height: 100%;
        padding-top: 44px;
        background: url('../../assets/image/detail_top.png') top no-repeat;
        background-size: 100% 170px;
      }
    }
  }

  .main {
    background-color: #f2f3f5 !important;
  }

  .mod {
    background-color: #fff !important;
  }

  .mod-hd {
    &::before {
      background-color: #286df7 !important;
    }
    span {
      color: #1d2129 !important;
    }
    em {
      color: #4e5969 !important;
    }
  }

  .table {
    .thead {
      .th {
        color: #949da8 !important;
      }
    }
    .tbody {
      .tr {
        .td {
          span {
            color: #1d2129 !important;
          }
          em {
            color: #949da8 !important;
          }
        }

        .lock {
          // 空 block 也保留，便于未来扩展
          span {
            border-color: #286df7 !important;
            color: #286df7 !important;
            background-color: #fff !important;
          }
        }
      }
    }
  }

  .xhfcjl {
    .table-title {
       color: #949da8;
    }
    .table-content {
      .date {
         color:#4e5969 !important;
      }
      .stock-info {
        .stock-info-title {
          color: #1d2129 !important;
        }
        em {
          color: #949da8 !important;
        }
      }
      .green-background {
        background:#e8ffec !important;
        color: #1eac4e !important;
      }
      .red-background {
        background:#ffece8 !important;
        color: #ef3939 !important;
      }
      .table-price {
        color: #1d2129 !important;
      }
    }
    .table-reason {
      .reason-desc {
        color: #1d2129 !important;
        .link-button {
          color: #7ea7fa !important;
        }
      }
    }
    .lock {
      span {
        background:#ffffff !important;
        border:1px solid #286df7 !important;
      }
    }
  }

  .expand {
    color: #949da8 !important;
  }

  .clfx {
    .info {
      color: #4e5969 !important;
    }

    .card {
      .item {
        background-color: #f7f8fa !important;
        color: #4e5969 !important;
      }
    }

    .hcfx {
      .item {
        background-color: #f7f8fa !important;

        .label {
          color: #4e5969 !important;
        }
      }
    }

    .tips {
      color: #949da8 !important;
    }
  }

  .fixed-button {
    background-color: #fff !important;

    span {
      border-color: #286df7 !important;
      color: #286df7 !important;

      &:nth-child(1) {
        background-color: #286df7 !important;
      }
    }
  }

  // 空数据
  .empty-info {
    .empty-text {
      color: #4e5969;
    }
  }
}
</style>
